import { render, staticRenderFns } from "./StarterServices.vue?vue&type=template&id=51bf2f6d&scoped=true&"
import script from "./StarterServices.vue?vue&type=script&lang=js&"
export * from "./StarterServices.vue?vue&type=script&lang=js&"
import style0 from "./StarterServices.vue?vue&type=style&index=0&id=51bf2f6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bf2f6d",
  null
  
)

export default component.exports